<template>
    <div class="main">
        <c-panel title="CONFIGURAÇÃO DE FREQUÊNCIA" titleIcon="fas fa-user-check">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="A política vale por herança: turma, depois etapa da matriz, depois escola, depois rede. A primeira configuração aplicável vence."></el-alert>

            <!--
                ITEM 89 — o desempenho só pode ser lançado depois do início das aulas, e o
                início vem da data inicial do período letivo da escola. Escola sem essa data
                fica FORA da validação — o gestor precisa enxergar isso, senão a regra existe
                no código e ninguém sabe onde ela não está valendo.
            -->
            <!--
                A `description` do el-alert é SUBSTITUÍDA quando o slot padrão tem conteúdo.
                Com o botão dentro do alerta, o aviso ficava só com o título: aparecia em
                âmbar chamando atenção e não dizia nada — nem quantas escolas, nem o efeito.
                Por isso o texto vem no slot, junto do botão.
            -->
            <el-alert v-if="diagnostico && diagnostico.aviso" type="warning" :closable="false" class="u-mb-15"
                title="Validação de início das aulas">
                <!-- `span`, não `div`: o Element envolve o slot num `<p>`, e bloco dentro de parágrafo é aninhamento inválido. -->
                <span class="aviso-diagnostico">{{ avisoPartes.antes
                    }}<a class="link-diagnostico" @click="dialogDiagnostico = true">{{ avisoPartes.link }}</a>{{ avisoPartes.depois }}</span>
            </el-alert>

            <el-alert v-else-if="diagnostico" type="success" :closable="false" class="u-mb-15"
                title="Validação de início das aulas ativa em todas as escolas"
                description="Todas as escolas têm data inicial de período letivo definida, então o lançamento de desempenho antes do início das aulas é bloqueado em toda a rede."></el-alert>

            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="6">
                    <el-select v-model="filtro.escopo" placeholder="Todos os escopos" clearable style="width: 100%;" @change="load">
                        <el-option v-for="e in escopos" :key="e" :value="e" :label="rotuloEscopo(e)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-select v-model="filtro.modo_apuracao" placeholder="Todos os modos" clearable style="width: 100%;" @change="load">
                        <el-option value="dia" label="Por dia"></el-option>
                        <el-option value="aula" label="Por aula"></el-option>
                                            <el-option value="total_periodo" label="Total de faltas no período"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button @click="abrirEfetiva" plain>CONSULTAR CONFIGURAÇÃO DE UMA TURMA</el-button>
                    <router-link v-if="podeEscrever" to="/admin/configuracao-frequencia/cadastro" class="btn-new-register u-ml-10">
                        <el-button type="primary">NOVA CONFIGURAÇÃO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th style="width: 150px;">Escopo</th>
                            <th class="hidden-mobile" style="width: 110px;">Alvo</th>
                            <th style="width: 130px;">Modo</th>
                            <th class="hidden-mobile u-text-center" style="width: 120px;">Freq. mínima</th>
                            <th class="hidden-mobile u-text-center" style="width: 110px;">Abono</th>
                            <th style="width: 150px;" class="u-text-center" v-if="podeEscrever">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ rotuloEscopo(item.escopo) }}</td>
                            <td class="hidden-mobile">{{ item.escopo_id || '—' }}</td>
                            <td style="text-transform: uppercase;">{{ rotuloModo(item.modo_apuracao) }}</td>
                            <td class="hidden-mobile u-text-center">{{ item.frequencia_minima }}%</td>
                            <td class="hidden-mobile u-text-center">{{ item.permite_abono ? 'Permite' : 'Não permite' }}</td>
                            <td class="u-text-center acao" v-if="podeEscrever">
                                <router-link :to="'/admin/configuracao-frequencia/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td :colspan="podeEscrever ? 7 : 6" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum registro encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="getPage" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <el-dialog title="Escolas sem data inicial de período letivo" :visible.sync="dialogDiagnostico" width="60%" append-to-body>
                <p class="u-mb-10">
                    Enquanto a data inicial não for informada, o sistema não consegue afirmar quando as aulas
                    começaram nessas escolas e, por isso, não bloqueia o lançamento antecipado de desempenho.
                </p>
                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr><th>Instituição</th><th style="width: 200px;">Período letivo</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="r in (diagnostico ? diagnostico.registros : [])" :key="r.id">
                                <td>{{ r.instituicao || '(instituição ' + r.instituicao_id + ')' }}</td>
                                <td>{{ r.periodo_letivo || r.periodo_letivo_id }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-dialog>

        </c-panel>

        <!-- Configuração EFETIVA de uma turma -->
        <el-dialog title="Configuração efetiva da turma" :visible.sync="dialogEfetiva" width="640px">
            <el-form label-position="top" class="u-mt-20">
                <!--
                    O seletor de escola só aparece para quem NÃO tem escola fixada — perfis
                    de rede. Antes o modal usava `config.instituicao` direto e, para esses
                    perfis, ela é nula: a busca de turmas nem era feita e o select mostrava
                    "Sem dados" sem dizer que faltava escolher a escola.
                -->
                <el-row :gutter="10" v-if="!escolaFixa">
                    <el-col :xs="24">
                        <el-form-item label="Escola">
                            <el-select v-model="escolaEfetiva" filterable style="width: 100%;"
                                placeholder="Selecione a escola" @change="carregarTurmasEfetiva">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="18">
                        <el-form-item label="Turma">
                            <el-select v-model="turmaEfetiva" filterable style="width: 100%;"
                                :placeholder="escolaEfetiva ? 'Selecione a turma' : 'Selecione a escola primeiro'"
                                :disabled="!escolaEfetiva">
                                <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="6" style="padding-top: 30px;">
                        <el-button type="primary" @click="consultarEfetiva" :disabled="!turmaEfetiva">CONSULTAR</el-button>
                    </el-col>
                </el-row>

                <el-alert v-if="escolaEfetiva && !turmas.length" type="info" :closable="false" show-icon
                    title="Esta escola não tem turmas no período letivo corrente."></el-alert>
            </el-form>

            <template v-if="efetiva">
                <el-alert v-if="efetiva.divergente" type="warning" :closable="false" class="u-mb-15" :title="efetiva.aviso"></el-alert>
                <el-alert v-else-if="efetiva.indeterminado" type="warning" :closable="false" class="u-mb-15" :title="efetiva.aviso"></el-alert>

                <div class="container-table">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <td style="width: 220px;">Modo efetivo</td>
                                <td style="text-transform: uppercase;">
                                    <strong v-if="efetiva.modo_apuracao">{{ rotuloModo(efetiva.modo_apuracao) }}</strong>
                                    <!-- BLOCO Q: o backend declara se há data das faltas. -->
                                    <el-tag v-if="efetiva.tem_data_de_falta === false" type="warning" size="mini" style="margin-left:6px;">sem data das faltas</el-tag>
                                    <em v-else>não determinado</em>
                                </td>
                            </tr>
                            <tr><td>Origem da configuração</td><td>{{ rotuloOrigem(efetiva.origem) }}</td></tr>
                            <tr><td>Horários por dia da turma</td><td>{{ efetiva.qtd_horarios === null ? '—' : efetiva.qtd_horarios }}</td></tr>
                            <tr><td>Modo praticado hoje</td><td>{{ efetiva.modo_legado ? (efetiva.modo_legado === 'dia' ? 'Por dia' : 'Por aula') : '—' }}</td></tr>
                            <tr><td>Frequência mínima</td><td>{{ efetiva.frequencia_minima === null ? '—' : efetiva.frequencia_minima + '%' }}</td></tr>
                            <tr><td>Abono de falta</td><td>{{ efetiva.permite_abono === null ? '—' : (efetiva.permite_abono ? 'Permite' : 'Não permite') }}</td></tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: { escopo: '', modo_apuracao: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        escopos: ['turma', 'matriz_etapa', 'instituicao', 'rede'],
        dialogEfetiva: false,
        turmas: [],
        instituicoes: [],
        escolaEfetiva: null,
        turmaEfetiva: '',
        efetiva: null,
        diagnostico: null,
        dialogDiagnostico: false
    }),
    computed: {
        // Perfis de rede e também diretor/coordenador/vice, restritos à própria escola
        // pela guarda do backend.
        podeEscrever () { return [1, 3, 4, 5, 6, 7, 12].includes(Number(this.$store.state.user.tipo)) },

        /** Escola do contexto, quando o perfil tem uma. Perfis de rede não têm. */
        escolaFixa () {
            const i = this.$store.state.config.instituicao
            return i && i.id ? i.id : null
        },

        /**
         * Quebra o aviso em três partes para transformar o trecho com o número num link.
         *
         * O TRECHO VEM DO BACKEND em `aviso_alvo`, junto da frase. Antes eu remontava
         * "N instituição(ões)" aqui para procurar no texto — o que amarrava a tela à
         * redação exata do backend e quebrava o link em silêncio quando a frase mudasse.
         * Foi o que aconteceu ao corrigir a concordância de singular e plural.
         *
         * O fallback continua: sem o trecho, o link vai para o fim e o aviso segue
         * levando ao diálogo.
         */
        avisoPartes () {
            const d = this.diagnostico
            if (!d || !d.aviso) return { antes: '', link: '', depois: '' }

            const alvo = d.aviso_alvo
            const i = alvo ? d.aviso.indexOf(alvo) : -1

            if (i < 0) return { antes: d.aviso + ' ', link: 'Ver escolas', depois: '' }

            return {
                antes: d.aviso.slice(0, i),
                link: alvo,
                depois: d.aviso.slice(i + alvo.length)
            }
        }
    },
    mounted () { this.load(); this.carregarDiagnosticoInicioAulas() },
    methods: {
        // Rótulo dos modos de apuração. A REGRA de cada modo vive no backend; aqui só o texto.
        rotuloModo (modo) {
            return { dia: 'Por dia', aula: 'Por aula', total_periodo: 'Total de faltas no período' }[modo] || modo
        },
        /** ITEM 89 — em quais escolas a validação de início das aulas está ou não valendo. */
        carregarDiagnosticoInicioAulas () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/diagnosticoInicioAulas`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) return
                this.diagnostico = r.data
            }).catch(() => {})
        },
        rotuloEscopo (e) {
            const r = { rede: 'Rede', instituicao: 'Instituição', matriz_etapa: 'Etapa da matriz', turma: 'Turma' }
            return r[e] || e
        },
        rotuloOrigem (o) {
            const r = {
                turma: 'Configuração da turma', matriz_etapa: 'Configuração da etapa da matriz',
                instituicao: 'Configuração da instituição', rede: 'Configuração da rede',
                legado: 'Nenhuma configuração — comportamento atual do sistema'
            }
            return r[o] || o
        },
        load () {
            this.statusList = false
            this.items = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/getAllPaginate?page=${this.paginate.page}`,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirEfetiva () {
            this.dialogEfetiva = true
            this.efetiva = null

            // Perfil com escola fixa já resolve tudo; os de rede escolhem no próprio modal.
            if (this.escolaFixa) {
                this.escolaEfetiva = this.escolaFixa
                if (!this.turmas.length) this.carregarTurmasEfetiva()
                return
            }

            if (!this.instituicoes.length) {
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                    this.$store.getters.getHeaderAuth
                ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
            }
        },

        carregarTurmasEfetiva () {
            this.turmas = []
            this.turmaEfetiva = null
            this.efetiva = null

            const periodo = this.$store.state.config.periodo
            if (!this.escolaEfetiva || !periodo || !periodo.id) return

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.escolaEfetiva}/${periodo.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                // O endpoint devolve as turmas AGRUPADAS por curso; achatar é obrigatório.
                this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat()
            }).catch(() => { this.turmas = [] })
        },
        consultarEfetiva () {
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/getEfetiva/${this.turmaEfetiva}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.efetiva = r.data
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir esta configuração?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        getPage (page) { this.paginate.page = page; this.load() }
    }
}
</script>

<style scoped>
/* Mesma aparência da `description` nativa, que o slot substituiu. */
.link-diagnostico {
    color: #8a6100;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}

.link-diagnostico:hover { color: #6a4a00; }

.aviso-diagnostico {
    display: block;
    font-size: 12px;
    line-height: 1.4;
    margin: 3px 0 0;
}
</style>
